import { getReward } from '@/api/system.api.js'

import { mapMutations } from 'vuex'

export default {
  props: {
    giftData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    giftLog: {
      type: Object|Array,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      invitationDialogVisible: false,
      prizeDialogVisible: false,
    }
  },
  computed: {
    stage() {
      return this.$store.getters.stage
    },
    user() {
      return this.$store.getters.user
    },
    isLogin() {
      return Object.keys(this.user).length > 0
    },
    inviteCount() {
      return this.$store.getters.inviteCount
    }
  },
  methods: {
    ...mapMutations(['setTipsDialog', 'setLoginDialog']),
    invite() {
      if (!this.isLogin) {
        this.setLoginDialog({ visible: true })
        return false;
      }
      this.invitationDialogVisible = true
    },
    openRuleDialog() {
      this.$emit('viewRule', this.giftData.rule)
    },
    openBag() {
      if (!this.isLogin) {
        this.setLoginDialog({ visible: true })
        return false;
      }

      this.prizeDialogVisible = true
    },
    getGiftImg(name) {
      return require('@/assets/img/common/gift/' + name)
    },
    getReward(gift) {
      if (!this.isLogin) {
        this.setLoginDialog({ visible: true })
        return false;
      }

      if (!gift.finish) return false

      const params = {
        token: this.user.token,
        id: gift.id,
        type: gift.typeId,
      }
      getReward(params)
        .then((res) => {
          if (res.code != 0) {
            this.setTipsDialog({ visible: true, tips: res.msg })
          } else {
            this.setTipsDialog({ visible: true, tips: '领取成功' })
            this.$emit('afterGetReward')
          }
        })
    },
    handlePrizeSuccess() {
      this.$emit('success')
    },
  }
}